import { render } from "./UnusableChoicesSummaryDetails.vue?vue&type=template&id=53437347&scoped=true"
import script from "./UnusableChoicesSummaryDetails.vue?vue&type=script&lang=js"
export * from "./UnusableChoicesSummaryDetails.vue?vue&type=script&lang=js"

import "./UnusableChoicesSummaryDetails.vue?vue&type=style&index=0&id=53437347&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53437347"]])

export default __exports__